module.exports = __webpack_public_path__ + "static/media/thank.b4b047cf.png";